@if (
  order()?.assignedData ||
  (delegation()?.primaryDriver && delegation()?.vehicle)
) {
  <onyx-information-heading>
    {{ `${I18N}.realizedBy` | translate }}

    <onyx-icon-button
      actions
      color="gray"
      variant="transparent"
      [size]="32"
      icon="history-outlined"
      [circle]="true"
      onyxTooltip="labels.vehicleAndDriverHistory"
      (click)="openActivityModal()"
    ></onyx-icon-button>
  </onyx-information-heading>

  <div class="container">
    @if (vehicle() || trailer()) {
      <onyx-data-widget supheading="labels.vehicles">
        <ng-container heading>
          @if (vehicle(); as vehicle) {
            <ng-container
              [ngTemplateOutlet]="fleetLinkTemplate"
              [ngTemplateOutletContext]="{ fleet: vehicle }"
            ></ng-container>
          }
        </ng-container>

        <ng-container secondaryHeading>
          @if (trailer(); as trailer) {
            <ng-container
              [ngTemplateOutlet]="fleetLinkTemplate"
              [ngTemplateOutletContext]="{ fleet: trailer }"
            ></ng-container>
          }
        </ng-container>
      </onyx-data-widget>
    }

    @if (primaryDriver() || secondaryDriver()) {
      <onyx-data-widget supheading="labels.drivers">
        <ng-container heading>
          @if (primaryDriver(); as primaryDriver) {
            <ng-container
              [ngTemplateOutlet]="driverLinkTemplate"
              [ngTemplateOutletContext]="{ driver: primaryDriver }"
            ></ng-container>
          }
        </ng-container>

        <ng-container secondaryHeading>
          @if (secondaryDriver(); as secondaryDriver) {
            <ng-container
              [ngTemplateOutlet]="driverLinkTemplate"
              [ngTemplateOutletContext]="{ driver: secondaryDriver }"
            ></ng-container>
          }
        </ng-container>
      </onyx-data-widget>
    }
  </div>
}

<ng-template let-fleet="fleet" #fleetLinkTemplate>
  <onyx-icon
    [name]="getFleetIcon(fleet.generalInformation.category)"
    [size]="20"
  ></onyx-icon>

  <app-module-link
    module="fleet"
    color="black"
    font="f-heading-m"
    (linkClick)="openFleetModal(fleet)"
  >
    {{ fleet | fleetIdentifier }}
  </app-module-link>
</ng-template>

<ng-template let-driver="driver" #driverLinkTemplate>
  <onyx-avatar
    variant="user"
    [size]="20"
    [user]="driver.driverData"
  ></onyx-avatar>

  <app-module-link
    module="drivers"
    color="black"
    font="f-heading-m"
    (linkClick)="openDriverModal(driver)"
  >
    {{ driver.driverData | onyxName }}
  </app-module-link>
</ng-template>
